import {
  Tabs,
  Tab,
  TabTitleText,
  Stack,
  StackItem,
} from '@patternfly/react-core';
import { useHistory, useLocation } from 'react-router-dom';
import React, { useState } from 'react';
import './AccountNav.scss';
import AccountHeader from '../../General/AppHeader/AppHeader';
import Env from '../../../utils/env';

const AccountNav = () => {
  const history = useHistory();
  const { pathname } = useLocation();

  const base = Env.routePrefix.replace(/\/$/, '');
  
  const [activeTab, setActiveTab] = useState(
    pathname === base || pathname === `${base}/`
    ? 'agreements' : pathname.slice(base.length + 1)
  );
  
  const onSelect = (
    _event: React.MouseEvent<HTMLElement, MouseEvent>,
    eventKey: string | number
  ) => {
    const newTab = eventKey.toString();
    if (newTab !== activeTab) {
      history.push(`${Env.routePrefix}/${newTab}`);
      setActiveTab(newTab);
    }
  };
  return (
    <Stack className="account-header">
      <StackItem>
        <AccountHeader title="Account Details" />
      </StackItem>
      <StackItem className="account-header__account-nav">
        <Tabs activeKey={activeTab} onSelect={onSelect}>
          <Tab
            eventKey="my-profile"
            title={<TabTitleText>My profile</TabTitleText>}
            tabContentId="my-profile"
          />
          <Tab
            eventKey="company-profile"
            title={<TabTitleText>Company profile</TabTitleText>}
            tabContentId="company-profile"
          />
          <Tab
            eventKey="team-members"
            title={<TabTitleText>Team members</TabTitleText>}
            tabContentId="team-members"
          />
          <Tab
            eventKey="agreements"
            title={<TabTitleText>Agreements</TabTitleText>}
            tabContentId="agreements"
          />
          <Tab
            eventKey="api-keys"
            title={<TabTitleText>API keys</TabTitleText>}
            tabContentId="api-keys"
          />
        </Tabs>
      </StackItem>
    </Stack>
  );
};

export default AccountNav;
